// extracted by mini-css-extract-plugin
module.exports = {"container":"Tab-module--container--1dk5D","button":"Tab-module--button--2kjFZ","contactInfo":"Tab-module--contactInfo--2ao2T"};